// physical-key normalization for mnemonic accelerators.
//
// we deliberately match KeyboardEvent.code and never .key: on macOS Option+S
// emits "ß" and Option+E is a dead key, so .key differs per-OS and per-layout.
// .code names the physical key and is identical everywhere.

export const isMac = () =>
  typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform || '');

export const MOD_LABEL = () => (isMac() ? 'Option' : 'Alt');

/** "KeyS" -> "s", "Digit4" -> "4"; anything else is not mnemonic-able. */
export function codeToChar(code) {
  if (!code) return null;
  if (code.startsWith('Key') && code.length === 4) return code[3].toLowerCase();
  if (code.startsWith('Digit') && code.length === 6) return code[5];
  return null;
}

export function charToCode(char) {
  if (!char) return null;
  const c = String(char).trim();
  if (/^[a-z]$/i.test(c)) return `Key${c.toUpperCase()}`;
  if (/^[0-9]$/.test(c)) return `Digit${c}`;
  return null;
}

/**
 * Alt held, with no other modifier. Ctrl/Meta are excluded so we never shadow
 * browser or OS chords; AltGr arrives as ctrl+alt on Windows and must stay
 * available for text entry on non-US layouts.
 */
export function isAltCombo(event) {
  return !!event.altKey && !event.ctrlKey && !event.metaKey;
}

/** The mnemonic character this event addresses, or null. */
export function eventToBinding(event) {
  if (!isAltCombo(event)) return null;
  return codeToChar(event.code);
}
